<template>
    <div class="category-autocomplete-options">
        <div :key="0" class="category-autocomplete-options__option" @click="findOffers({})">
            <div>
                {{ $t('components.offer.category_autocomplete_options.find_offers_by') }}
                <b>{{ searchTerm }}</b>
                {{ $t('common.microcopy.in') }}
                <common-icon name="logo" size="tiny-small"></common-icon>
            </div>
        </div>
        <div
            v-for="option in options"
            :key="option.serviceId"
            class="category-autocomplete-options__option"
            @click="findOffers(option)"
        >
            <div>
                {{ $t('components.offer.category_autocomplete_options.find_offers_by') }}
                <b>{{ searchTerm }}</b>
                {{ $t('common.microcopy.in') }} {{ getOptionTitle(option) }}
            </div>
        </div>
    </div>
</template>

<script>
    import RoutesEnum from 'enums/routes.enum'
    import LanguageEnum from 'enums/language.enum'
    import Store from '@/store'

    export default {
        props: {
            options: { type: Array, required: true },
            searchTerm: { type: String, default: '' },
        },

        methods: {
            findOffers({ serviceId, serviceGroupId }) {
                const query = { filter: this.searchTerm?.trim(), includeDescription: true }
                if (serviceId && serviceGroupId) {
                    query.serviceId = serviceId
                    query.serviceGroupId = serviceGroupId
                }
                if (Store?.getters['data/getCountryByGeolocation']) {
                    query.countryId = Number(Store?.getters['data/getCountryByGeolocation'])
                }
                this.$router.push({ name: RoutesEnum.OFFER.FIND, query })
                this.emitEvent({ name: 'filter-selected' })
            },

            getOptionTitle(option) {
                return this.$i18n.locale === LanguageEnum.EN
                    ? `${option.serviceGroupNameEN} > ${option.serviceNameEN}`
                    : `${option[`serviceGroupName${this.$i18n.locale.toUpperCase()}`]} > ${
                          option[`serviceName${this.$i18n.locale.toUpperCase()}`]
                      }`
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/variables';

    .category-autocomplete-options {
        &__option {
            height: 40px;
            background: white;
            font-size: $font-size--hint;
            padding: 9px 20px;
            margin: auto;
            line-height: 12px;
            display: flex;
            align-items: center;
            &:hover {
                background: $color--bg-input--hover;
            }
        }
    }
</style>
